import { useEffect, useState } from "react";

type ProductArtworkProps = {
  src?: string | null;
  alt: string;
  className?: string;
  priority?: boolean;
  onImageError?: () => void;
};

export function ProductArtwork({ src, alt, className = "", priority = false, onImageError }: ProductArtworkProps) {
  const [hasFailed, setHasFailed] = useState(false);

  useEffect(() => setHasFailed(false), [src]);

  if (!src || hasFailed) {
    return null;
  }

  return (
    <img
      src={src}
      alt={alt}
      loading={priority ? "eager" : "lazy"}
      decoding="async"
      fetchPriority={priority ? "high" : "auto"}
      onError={() => {
        setHasFailed(true);
        onImageError?.();
      }}
      className={`block object-contain ${className}`}
    />
  );
}
